
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cannabis-strains/[slug]",
      function () {
        return require("private-next-pages/cannabis-strains/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cannabis-strains/[slug]"])
      });
    }
  